class Ebook {
  constructor() {
    if(document.querySelector('.ebook') != null && document.querySelector('.ebook') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {
    $('.ebook__slick').slick({
      centerMode: true,
      centerPadding: '10px',
      slidesToShow: 1,
      dots: true,
      arrows: false,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: true
          }
        }
      ]
    });
  }
}

$(document).ready(function() {
  const ebook = new Ebook();
});